module.exports = __webpack_public_path__ + "static/media/GPLR.6fd8c470.JPG";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/GPLR.JPG
// module id = 1548
// module chunks = 1